var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.nonAnsweredNames.length > 0)?_c('span',[_c('font-awesome-icon',{attrs:{"icon":"clock"}}),_vm._v(" "+_vm._s(_vm.nonAnsweredNames))],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }